module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-02.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Frontmatter02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ABOUT THIS BOOK")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Frontmatter03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ABOUT ME")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Frontmatter04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHAT IS QUILTING?")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Frontmatter05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WHAT IS PATCHWORK?")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Frontmatter06"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MY QUICK TIPS")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QUILTING ESSENTIALS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sewing machine")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools & equipment")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quilting fabrics")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fabric terminology")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wadding")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Threads")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QUILTING KNOW-HOW")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caring for your quilt")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cutting")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Machine stitches")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appliqué")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quilt sandwich")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Straight line quilting")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quilt-as-you-go")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free-motion embroidery")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-bound straight binding")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Mini Chicken Quilt")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bias binding")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Beach Hut Hanger")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trapunto")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Trapunto Stocking")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stitch in the ditch")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adding borders")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Table Runner")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Quilted Tote")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashing")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Bunting Quilt")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Bargello Pillowcase")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Echo quilting")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tying a quilters’ knot")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English paper piecing")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Snowflake Placemat")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bag making")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hand quilting")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big stitch quilting")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Reverse Appliqué Messenger Bag")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tying your quilt")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROJECT Humbug Hexie Quilt")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TEMPLATES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0